import React from 'react';
import Box from '@mui/material/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const RangeFields = ({
  from,
  to,
}: {
  from: React.ReactNode;
  to: React.ReactNode;
}) => (
  <Box display="flex" alignItems="baseline" gap={1} flexWrap="wrap">
    <Box flexGrow={1}>
      {from}
    </Box>
    <Box alignSelf="center" display="flex" alignItems="center">
      <ArrowForwardIcon />
    </Box>
    <Box flexGrow={1}>
      {to}
    </Box>
  </Box>
);

export default RangeFields;
